import 'jquery-validation';
import { init as wooCommerceInit } from './form-wc';
import { customValidationInit } from './form-custom-validation';
import { dynamicFieldsInit } from './form-dynamic-fields';
import { giwDrtvInit } from './form-giw';
import { init as cf7HandlersInit } from './form-cf7-handlers';
import { init as datePickerInit } from './form-date-picker';
import { init as formTrackingInit } from './form-tracking';
import { init as nationalServiceInit } from './form-national-contact';
import { multiStepFormInit } from './form-multistep';
import { requestServiceInit } from './form-request-a-service';
import { hasValueInit } from './form-has-value';

export function init() {
  hasValueInit();
  cf7HandlersInit();
  datePickerInit();
  wooCommerceInit();
  customValidationInit();
  dynamicFieldsInit();
  multiStepFormInit();
  formTrackingInit();
  nationalServiceInit();
  requestServiceInit()
  giwDrtvInit();
}
